import { useLocation } from "react-router-dom";

export const useCurrentProduct = () => {
  const { pathname } = useLocation();

  const isOnBooks = pathname.startsWith("/books");

  return { isOnBooks };
};
